<template>
  <label class="relative text-sm md:text-base flex !leading-[120%] items-center" :for="idFor">
    <span class="mr-2">
      <svg v-if="!icon" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 6.5C12 9.81371 9.31371 12.5 6 12.5C2.68629 12.5 0 9.81371 0 6.5C0 3.18629 2.68629 0.5 6 0.5C9.31371 0.5 12 3.18629 12 6.5Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 11.5C8.76142 11.5 11 9.26142 11 6.5C11 3.73858 8.76142 1.5 6 1.5C3.23858 1.5 1 3.73858 1 6.5C1 9.26142 3.23858 11.5 6 11.5ZM6 12.5C9.31371 12.5 12 9.81371 12 6.5C12 3.18629 9.31371 0.5 6 0.5C2.68629 0.5 0 3.18629 0 6.5C0 9.81371 2.68629 12.5 6 12.5Z"
          fill="#CFD1D6"
        />
      </svg>
      <template v-if="icon">
        <span v-html="icon" />
      </template>
    </span>
    {{ content }}
  </label>
</template>

<script>
export default {
  name: 'AtomSwitchLabel',
  props: ['idFor', 'content', 'icon'],
}
</script>
